import { render, staticRenderFns } from "./SubstituitionBudgetItem.vue?vue&type=template&id=624e8323&"
import script from "./SubstituitionBudgetItem.vue?vue&type=script&lang=js&"
export * from "./SubstituitionBudgetItem.vue?vue&type=script&lang=js&"
import style0 from "./SubstituitionBudgetItem.vue?vue&type=style&index=0&id=624e8323&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports